import React from "react";
import { useState, useEffect } from 'react';

export function useWindowWidth() {
  const [width, setWidth] = useState<number>(0);
  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const updateWidth = () => setWidth(window.innerWidth);
      updateWidth();
      window.addEventListener('resize', updateWidth);
      
      return () => window.removeEventListener('resize', updateWidth);
    }
  }, []);
  
  return width;
}

interface Breakpoint {
  minWidth: number;
  component: React.ReactNode;
}

interface ResponsiveComponentSwitchProps {
  breakpoints: Breakpoint[];
  defaultComponent: React.ReactNode;
}

export const ResponsiveComponentSwitch: React.FC<ResponsiveComponentSwitchProps> = ({
  breakpoints,
  defaultComponent,
}) => {
  const windowWidth = useWindowWidth();

  const sortedBreakpoints = [...breakpoints].sort(
    (a, b) => b.minWidth - a.minWidth
  );

  for (const bp of sortedBreakpoints) {
    if (windowWidth >= bp.minWidth) {
      return <>{bp.component}</>;
    }
  }

  return <>{defaultComponent}</>;
}

export default ResponsiveComponentSwitch;
